//@ts-ignore
import DesignIcon from '../icons/my-location.svg';
//@ts-ignore
import GraphicDesignIcon from '../icons/graphic.png';
//@ts-ignore
import DevelopmentIcon from '../icons/developer.svg';

export const providedServices = [
  {
    title: 'UI/UX Designing',
    description:
      'I design modern and modular websites, web applications and android applications.',
    icon: DesignIcon
  },
  {
    title: 'Web Design & Development',
    description:
      'I provide frontend design and development support based on the above technologies.',
    icon: DevelopmentIcon
  },
  {
    title: 'Graphic Designing',
    description:
      'I design unique graphics and logos for websites and applications.',
    icon: GraphicDesignIcon
  }
];
